import React, { useState } from 'react';
import { connect } from 'react-redux';
import Modal from '../Modal';
import { Form } from 'antd';
import TEXT from '../Text';
import { ButtonPrimary, ButtonSecondary } from '../Button';
import { createAdminFeeWallets } from '../../../redux/actions/adminPanel/adminFeeWallets';
import CurrencyDropdown from '../CurrencyDropdown';
import './style.scss';
import { useTranslation } from "react-i18next";

const AddWalletModal = ({
  typeNetwork,
  showAddNewWalletModal,
  updateWalletsList,
  setShowAddNewWalletModal,
  createAdminFeeWallets,
}) => {
  const [isFetching, setIsFetching] = useState(false);
  const [form] = Form.useForm();

  const { t } = useTranslation();

  const handleClose = () => {
    setShowAddNewWalletModal(false);
    form.resetFields();
  };

  const setCurrencies = values => {
    form.setFieldsValue({ currencyId: values });
  };

  const handleSubmit = async (body) => {
    setIsFetching(true);
    const response = await createAdminFeeWallets(body);
    setIsFetching(false);
    if (response) {
      handleClose();
      updateWalletsList();
    }
  };

  return (
    <Modal
      title={t('admin.create_wallet')}
      visible={showAddNewWalletModal}
      width={385}
      footerComponent={
        <div className="add-user-modal__buttons-wrap">
          <ButtonSecondary onClick={handleClose}>{t('admin.cancel')}</ButtonSecondary>
          <ButtonPrimary loading={isFetching} disabled={isFetching} onClick={form.submit}>
            {t('admin.add')}
          </ButtonPrimary>
        </div>
      }
      onCancel={handleClose}
    >
      <div className="add-wallet-modal">
        <Form
          form={form}
          name="add-wallet-modal"
          autoComplete="off"
          initialValues={{
            currencyId: '',
            // setMain: true,
          }}
          onFinish={values => handleSubmit({ setMain: true, typeNetwork, currenciesIds: [values.currencyId] })}
        >
          <div className="add-wallet-modal__currencies">
            <TEXT.label>{t('admin.currency')}</TEXT.label>
            <Form.Item name="currencyId" valuePropName="merchantCurrencies">
              <CurrencyDropdown setFunc={setCurrencies} noTokens={true} />
            </Form.Item>
          </div>
          <button type="submit" hidden></button>
        </Form>
      </div>
    </Modal>
  );
};

const mapStateToProps = state => ({
  typeNetwork: state.networkFilter,
});

const mapDispatchToProps = {
  createAdminFeeWallets,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddWalletModal);
